/**
 * Item display names (`presentation.displayNames`), as pure functions of the table: no catalog import, so
 * the content tools can use them on a source they are editing. The game reads them through
 * item/display_name.ts, which binds the table from the live catalog.
 */

/**
 * An id read as words: "roof-wood" -> "Roof wood", "strawBedSmall" -> "Straw bed small". What a new item
 * is called until somebody names it, and what the UI falls back to for an id with no name.
 */
export const defaultItemDisplayName = (itemType: string): string => {
    const words = String(itemType || "").replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[-_]+/g, " ").trim().toLowerCase()
    return words ? words[0].toUpperCase() + words.slice(1) : "Item"
}

/** An item's name in `names`: the colour's own name wins over the item's ("dagger:brown" over "dagger"). */
export const lookupItemDisplayName = (names: Record<string, string> | undefined, itemType: string, color?: string): string =>
    (color && names?.[`${itemType}:${color}`]) || names?.[itemType] || defaultItemDisplayName(itemType)
